export enum SupplementalHeatingSource {
  ElectricBoiler = 0,
  DistrictHeating = 1,
}
